import { Category } from '@wix/answers-api';
import { componentsToPlainText } from '@wix/kb-article-viewer';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, SEO } from '../../../constants';
import { ArticleWithComponents } from '../../../types';
import { shouldAddNoIndex } from '../../../utils/should-add-no-index';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type ArticlePageProps = {
  article?: ArticleWithComponents;
  categoriesTree?: Category[];
};

const MAX_DESCRIPTION_LENGTH = 160;

export const ArticlePageSEO: FunctionComponent<ArticlePageProps> = ({
  article,
  categoriesTree,
}) => {
  const resolveBabelSeo = useBabelSeo();

  const description = componentsToPlainText(article?.components || []).slice(
    0,
    MAX_DESCRIPTION_LENGTH
  );

  const title = resolveBabelSeo('seo.article_page.title', {
    articleTitle: article?.title || '',
  });

  const alternateDefaultUrl = article?.translations?.find(
    (e) => e.locale === LOCALES.EN
  )?.url;

  const noIndex = shouldAddNoIndex(article, categoriesTree);
  const robots = {
    noArchive: false,
    noFollow: false,
    noIndex: noIndex ?? false,
  };

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={SEO.SOCIAL_IMAGE_URL}
        robots={robots}
      />
      <Head>
        {article?.translations?.map(({ url, locale: localeTr }) => (
          <link rel="alternate" hrefLang={localeTr} href={url} key={url} />
        ))}
        {alternateDefaultUrl && (
          <link
            rel="alternate"
            hrefLang="x-default"
            href={alternateDefaultUrl}
          />
        )}
      </Head>
    </>
  );
};
